module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowBlueDisabled-163da131c06514ea9f55524572827447.svg";